// This icon file is generated automatically.
var PHeatMapOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.93 12.38L7.43 1.12A.5.5 0 007 .88a.5.5 0 00-.43.26L.07 12.38a.5.5 0 00.43.74h13a.5.5 0 00.43-.74zM1.58 12L7 2.62 12.42 12H1.58zm4.99-7.4L3 10.74a.5.5 0 00.44.75h7.12a.5.5 0 00.43-.75L7.43 4.59A.5.5 0 007 4.34a.5.5 0 00-.43.25zm3.34 6.03H4.1L7 5.58l2.91 5.04zM6.57 7.58l-.9 1.54a.5.5 0 00.44.74h1.78a.5.5 0 00.43-.74l-.89-1.54A.5.5 0 007 7.34a.5.5 0 00-.43.25zm.89 1.54h-.92l.46-.8.46.8z", "fill-rule": "nonzero" } }] }, "name": "p-heat-map", "theme": "outlined" };
export default PHeatMapOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PHeatMapOutlined.js
// module id = 3444
// module chunks = 0